import '@/plugins/element/index'
import '@/plugins/vant/index'
import '@/plugins/components/admin'
import '@/plugins/components/views'

export default {}
